<template>
  <div class="address">
    <van-nav-bar
      title="收货地址"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />

    <van-address-list
      v-model="chosenAddressId"
      :list="list"
      :switchable="switchable"
      @add="onAdd"
      @edit="onEdit"
      @select="onSelect"
    />
    <div v-if="isLoad && list.length===0" class="empty">
      暂无地址
    </div>
  </div>
</template>

<script>
import { myAddressList } from '@/api/address'
import { mapGetters } from 'vuex'
import { NavBar } from 'vant'
import { AddressList } from 'vant';
import AddressPanel from './components/AddressPanel'

export default {
  name: 'Address',
  components: {
    [NavBar.name]: NavBar,
    [AddressList.name]: AddressList,
    AddressPanel
  },
  data () {
    return {
      isLoad: false,
      chosenAddressId: '1',
      switchable: false,
      list: []
    }
  },
  computed: {
    ...mapGetters([
      'isCheckout',
      'checkoutPath',
      'checkoutAddress'
    ])
  },
  created () {
    this.getAddressList()
    const path = this.$route.query.path
    const addressId = this.$route.query.address_id
    if (this.$route.query.from === 'checkout' && addressId && path) {
      this.$store.dispatch('setIsCheckout', true)
      this.$store.dispatch('setCheckoutPath', path)
      this.$store.dispatch('setCheckoutAddress', addressId)
      this.chosenAddressId = parseInt(this.checkoutAddress)
    } else {
      this.$store.dispatch('setIsCheckout', false)
      this.$store.dispatch('setCheckoutPath', null)
      this.$store.dispatch('setCheckoutAddress', null)
    }
    this.switchable = !!this.isCheckout
  },
  methods: {
    async getAddressList () {
      const res = await myAddressList()
      this.list = res.data.map((item) => {
        return {
          id: item.uuid,
          name: item.name,
          tel: item.tel,
          address: `${item.province}${item.city}${item.county}${item.detail}`
        }
      })
      this.isLoad = true
    },
    onAdd() {
      this.$router.push(`/my/address/detail`)
    },
    onEdit(item, index) {
      this.$router.push(`/my/address/detail?address_id=${item.id}`)
    },
    onSelect (item, index) {
      this.$store.dispatch('setCheckoutAddress', item.id)
      this.$router.replace(this.checkoutPath)

    },
    back () {
      if (this.isCheckout) {
        this.$router.replace(this.checkoutPath)
      } else {
        // this.$router.back()
        this.$router.push('/my')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.address {
}
</style>
